import { render, staticRenderFns } from "./ClientPortfolioChart.vue?vue&type=template&id=d30ef70a&"
import script from "./ClientPortfolioChart.vue?vue&type=script&lang=js&"
export * from "./ClientPortfolioChart.vue?vue&type=script&lang=js&"
import style0 from "./ClientPortfolioChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports